module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_1_0@3x.f4987c80.png";